import { createContext } from "react";
import { appInitialState } from "../store/reducers/appReducer";
import { IAppState } from "../types"

export interface IAppContextProps {
    state?: IAppState
}

export const AppContext = createContext<IAppContextProps>({ state: appInitialState })